import * as sdk from 'matrix-js-sdk';

export const getCurrentRoomId = async (
  matrixClient: sdk.MatrixClient,
  documentId: string
): Promise<string | null> => {
  try {
    if (!matrixClient || !documentId) {
      return null;
    }

    const rooms = await matrixClient.getRooms();
    const foundRoom = rooms.find((room) =>
      room.getCanonicalAlias()?.includes(documentId)
    );

    return foundRoom ? foundRoom.roomId : null;
  } catch (error) {
    console.error('Failed to get room id: ', error);
    return null;
  }
};
